import { getPlainCookie, deleteCookies, getCookie } from './storageUtils';

/**
 * @description: Check if glt is present
 * @returns boolean
 */
export function isSessionValid() {
  const gigyaAPIKey = process.env.REACT_APP_GIGYA_KEY;
  const gigyaGltCookie = `glt_${gigyaAPIKey}`;

  return Boolean(getPlainCookie(gigyaGltCookie));
}

/**
 * @description: Check if JWT is expired
 * @returns boolean
 */
export function isJwtExpired(token) {
  if (!token) return true;

  try {
    const payloadBase64 = token.split('.')[1];
    const decodedJson = atob(payloadBase64);
    const payload = JSON.parse(decodedJson);

    if (!payload.exp) return false;

    const currentTime = Math.floor(Date.now() / 1000);

    return payload.exp - currentTime < 60;
  } catch (error) {
    console.error('Invalid token:', error);
    return true;
  }
}

/**
 * @description: Get JWT token from Gigya
 * @returns Promise<string>
 */
export function getJWTToken() {
  return new Promise((resolve, reject) => {
    if (!window?.gigya?.accounts) {
      return reject('Gigya not available');
    }
    
    window.gigya.accounts.getJWT({
      expiration: 900,
      callback: function (response) {
        if (response.errorCode === 0) {
          const token = response.id_token;
          window.gigyaAccDetails['auth_token'] = token;
          resolve(token);
        } else {
          reject(response);
        }
      },
    });
  });
}

/**
 * @description: Logout consumer
 * @returns void
*/
export function logout() {
  const gigyaAPIKey = process.env.REACT_APP_GIGYA_KEY;
  if (window?.gigya) {
    window.gigya.accounts.logout({
      callback: function (response) {
        if (response.errorCode === 0) {
          window.gigyaAccDetails = {};
          deleteCookies(['UID', 'username']);
          console.log('abc Redirecting to login after deleting cookies');
          window.location.href = '/eg/login';
        }
      },
    });
  } else {
    deleteCookies(['UID', 'username', `glt_${gigyaAPIKey}`]);
    window.location.href = '/eg/login';
  }
}

export function isUserLoggedIn() {
  return Boolean(isSessionValid() && getCookie('UID'))
}
